import { NavItem } from './nav-item/nav-item';
export const navItems: NavItem[] = [
  {
    navCap: 'SidebarTitle.Home',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.Dashboard',
    iconName: 'chart-bar',
    bgcolor: 'primary',
    route: '/dashboard',
    // permission:['dashboard_full_page']
  },
  {
    navCap: 'SidebarTitle.Apps',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.Calendar',
    iconName: 'calendar-event',
    bgcolor: 'primary',
    route: 'apps/calendar',
  },
  {
    navCap: 'SidebarTitle.Lookups',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.Lookups',
    iconName: 'search',
    bgcolor: 'primary',
    children: [
      {
        displayName: 'SidebarTitle.GeneralInfo',
        iconName: 'world',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.Country.Country',
            iconName: 'flag',
            route: 'lookup/country',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Nationality.Nationalities',
            iconName: 'globe',
            route: 'lookup/nationality',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Genders',
            iconName: 'users',
            route: 'lookup/gender',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.SponsorshipTypes',
            iconName: 'heart-handshake',
            route: 'lookup/sponsorship/type',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Departments.Departments',
            iconName: 'briefcase',
            route: 'lookup/department',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Industries',
            iconName: 'building-skyscraper',
            route: 'lookup/industry',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Brand.Brands',
            iconName: 'package',
            route: 'lookup/brands',
            bgcolor: 'transparent',
          }, {
            displayName: 'Lookups.TicketTypes',
            iconName: 'ticket',
            route: 'lookup/ticket/type',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Contact.Type',
            iconName: 'address-book',
            route: 'lookup/contact/type',
            bgcolor: 'transparent',
          }
        ],
      },
      {
        displayName: 'SidebarTitle.StoresSetup',
        iconName: 'building-store',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.Stores.StoreTypes',
            iconName: 'building-warehouse',
            route: 'lookup/store/type',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Stores.StoreCategories',
            iconName: 'tags',
            route: 'lookup/store/category',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Stores.Store',
            iconName: 'building-store',
            route: 'lookup/store',
            bgcolor: 'transparent',
          },
        ],
      },
      {
        displayName: 'SidebarTitle.AreasSetups',
        iconName: 'map',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.AreaCategory.AreaCategories',
            iconName: 'layers-subtract',
            route: 'lookup/area/categories',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Area.Areas',
            iconName: 'map-2',
            route: 'lookup/area',
            bgcolor: 'transparent',
          }
        ],
      },
      {
        displayName: 'SidebarTitle.LocationsSetups',
        iconName: 'map',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.LocationCategories',
            iconName: 'category',
            route: 'lookup/location/category',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Locations.Locations',
            iconName: 'map-pin-filled',
            route: 'lookup/location',
            bgcolor: 'transparent',
          },
        ],
      },
      {
        displayName: 'SidebarTitle.Sections',
        iconName: 'layout-grid',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'SidebarTitle.Sections',
            iconName: 'layout-grid',
            route: 'lookup/section',
            bgcolor: 'primary',
          },
        ],
      },
      {
        displayName: 'SidebarTitle.FacilitieSetups',
        iconName: 'building-community',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.Facilities.Facilities',
            iconName: 'building',
            route: 'lookup/facility',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.FacilityTypes',
            iconName: 'building-estate',
            route: 'lookup/facility/type',
            bgcolor: 'transparent',
          },
        ],
      },
      {
        displayName: 'SidebarTitle.EventMgmt',
        iconName: 'calendar-event',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.EventCategories',
            iconName: 'category',
            route: 'lookup/event/category',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.EventTypes',
            iconName: 'presentation',
            route: 'lookup/event/type',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Events',
            iconName: 'calendar',
            route: 'lookup/event',
            bgcolor: 'transparent',
          },
        ],
      },
      {
        displayName: 'SidebarTitle.Sponsorship&Promo',
        iconName: 'table-heart',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.Promoters',
            iconName: 'device-mobile-heart',
            route: 'lookup/promoter',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Sponsors',
            iconName: 'heart-dollar',
            route: 'lookup/sponsor',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Merchant.Merchants',
            iconName: 'building-store',
            route: 'lookup/merchant',
            bgcolor: 'transparent',
          },
        ],
      },
      {
        displayName: 'SidebarTitle.StoriesSetup',
        iconName: 'device-mobile',
        bgcolor: 'primary',
        children: [
          {
            displayName: 'Lookups.Story.StoryTypes',
            iconName: 'slideshow',
            route: 'lookup/story/type',
            bgcolor: 'transparent',
          },
          {
            displayName: 'Lookups.Story.Story',
            iconName: 'video',
            route: 'lookup/story',
            bgcolor: 'transparent',
          }
        ],
      },
      {
        displayName: 'Lookups.SideMenu',
        iconName: 'menu',
        route: 'lookup/side/menu',
        bgcolor: 'transparent',
      },
    ],
  },
  {
    navCap: 'SidebarTitle.DocumentManagement',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.DocumentManagement',
    iconName: 'file-text',
    bgcolor: 'primary',
    children: [
      {
        displayName: 'Lookups.DocumentTypes',
        iconName: 'file-stack',
        route: 'dms/document/type',
        bgcolor: 'transparent',
      },
      {
        displayName: 'Lookups.EmailThreads',
        iconName: 'mail',
        route: 'dms/email/thread',
        bgcolor: 'transparent',
      },
    ],
  },
  {
    navCap: 'SidebarTitle.Setups',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.Setups',
    iconName: 'checkup-list',
    bgcolor: 'transparent',
    route: 'service',
    children: [
      {
        displayName: 'Services.Services',
        iconName: 'briefcase',
        bgcolor: 'transparent',
        route: 'service/service',
      },
      {
        displayName: 'Services.ServicesType.ServicesType',
        iconName: 'tools',
        bgcolor: 'transparent',
        route: 'service/type',
      }, {
        displayName: 'Services.ServiceStatus.ServiceStatus',
        iconName: 'mood-cog',
        bgcolor: 'transparent',
        route: 'service/status',
      },
      // {
      //   displayName: 'Services.ServiceConfiguration.ServiceConfiguration',
      //   iconName: 'settings',
      //   bgcolor: 'transparent',
      //   route: 'service/configuration',
      // },
    ]
  },
  {
    navCap: 'Evaluation.Evaluation',
    bgcolor: 'primary',
  },
  {
    displayName: 'Evaluation.QRGenerator',
    iconName: 'qr_code',
    bgcolor: 'transparent',
    route: 'user-evaluation/qrGenerator/qr',
  },
  {
    displayName: 'Evaluation.EvaluationSetups',
    iconName: 'layout',
    bgcolor: 'primary',
    route: 'lookup',
    children: [
      {
        displayName: 'Evaluation.Criteria',
        iconName: 'file-star',
        bgcolor: 'transparent',
        route: 'lookup/evaluation/criteria',
      },
      {
        displayName: 'Evaluation.Scale',
        iconName: 'scale',
        bgcolor: 'transparent',
        route: 'lookup/evaluation/scale',
      },
      {
        displayName: 'Evaluation.Subject',
        iconName: 'clipboard-list',
        bgcolor: 'transparent',
        route: 'lookup/evaluation/subject',
      },
    ],
  },
  {
    displayName: 'Evaluation.Reports',
    iconName: 'checkup-list',
    bgcolor: 'transparent',
    route: 'lookup',
    children: [
      {
        displayName: 'Evaluation.EvaluationResults',
        iconName: 'report-analytics',
        bgcolor: 'transparent',
        route: 'lookup/evaluation/results',
      },
      {
        displayName: 'Evaluation.EvaluationResultsByCriteria',
        iconName: 'report-analytics',
        bgcolor: 'transparent',
        route: 'lookup/evaluation/results/byCriteria',
      },
      {
        displayName: 'Evaluation.EvaluationResultsByAmenity',
        iconName: 'report-analytics',
        bgcolor: 'transparent',
        route: 'lookup/evaluation/results/byAmenity',
      },
    ],
  },
  {
    navCap: 'SidebarTitle.HR&Employees',
    bgcolor: 'primary',
  },
  {
    displayName: 'Lookups.Employees.Employees',
    iconName: 'id-badge',
    route: 'lookup/employee',
    bgcolor: 'transparent'
  },
  {
    navCap: 'SidebarTitle.ContentManagement',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.ContentManagement',
    iconName: 'app-window',
    bgcolor: 'primary',
    route: 'content',
    children: [
      {
        displayName: 'Content.ContentEntry.ContentEntry',
        iconName: 'edit',
        bgcolor: 'transparent',
        route: 'content/entry',
      },
      {
        displayName: 'Content.ContentType.ContentType',
        iconName: 'category',
        bgcolor: 'transparent',
        route: 'content/type',
      },
    ],
  },
  {
    navCap: 'SidebarTitle.CommunityManagement',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.CommunityManagement',
    iconName: 'network',
    bgcolor: 'primary',
    route: 'community',
    children: [
      {
        displayName: 'Community.Community.Communities',
        iconName: 'users-group',
        bgcolor: 'transparent',
        route: 'community/community',
      },
      {
        displayName: 'Community.CommunityCategory.CommunityCategory',
        iconName: 'grid-dots',
        bgcolor: 'transparent',
        route: 'community/category',
      },
    ],
  },
  {
    navCap: 'SidebarTitle.User&Access',
    bgcolor: 'primary',
  },
  {
    displayName: 'SidebarTitle.User&Access',
    iconName: 'users',
    bgcolor: 'primary',
    children: [
      {
        displayName: 'User.Users',
        iconName: 'user-circle',
        route: 'user/management/user',
        bgcolor: 'primary',
      },
      {
        displayName: 'Lookups.UserTypes',
        iconName: 'user-circle',
        route: 'lookup/user/types',
        bgcolor: 'transparent',
      },
      {
        displayName: 'Lookups.Roles',
        iconName: 'shield-lock',
        route: 'lookup/roles',
        bgcolor: 'transparent',
      },
      {
        displayName: 'Lookups.Module',
        iconName: 'cube',
        route: 'lookup/module',
        bgcolor: 'transparent'
      },
      {
        displayName: 'Lookups.Authority.Authority',
        iconName: 'lock',
        route: 'lookup/authority',
        bgcolor: 'transparent'
      },
      {
        displayName: 'Lookups.AuthorityType',
        iconName: 'user-shield',
        route: 'lookup/authority/type',
        bgcolor: 'transparent'
      },
    ],
  },
  {
    navCap: 'Configurations.Configurations',
    bgcolor: 'primary',
  },
  {
    displayName: 'Configurations.Configurations',
    iconName: 'settings',
    route: 'lookup/configuration',
    bgcolor: 'transparent',
  },
];
